import PageTitle from "~/components/ui/PageTitle";
import Tabs from "~/components/ui/Tabs";
import { settingsTabs } from "../tabs";
import { useTranslation } from "react-i18next";
import { Plans } from "~/components/plans";
import { useAccount } from "~/hooks/useAccount";
import { SubscriptionType } from "~/types/billing";
import { useDebounceEffect } from "~/hooks/useDebounceEffect";

const PlansSettingsPage = () => {
  const { t } = useTranslation();
  const { account } = useAccount();

  const initialIsAnnual =
    window.location.href.includes("?annual=true") ||
    account?.active_subscription?.plan?.interval === SubscriptionType.ANNUAL;

  return (
    <div>
      <PageTitle>{t("settings.title")}</PageTitle>
      <Tabs flexDirection="column" tabs={settingsTabs(account)}>
        <Plans initialIsAnnual={initialIsAnnual} />
      </Tabs>
    </div>
  );
};

export default PlansSettingsPage;
